module.exports = __webpack_public_path__ + "img/cancel_icon2.0111226e.svg";